import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-guide-pages',
  templateUrl: './guide-pages.component.html',
  styleUrls: ['./guide-pages.component.css'],
})
export class GuidePagesComponent implements OnInit {
  htmlContent: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private title: Title
  ) { }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  ngOnInit(): void {
    this.route.url.subscribe((segment) => {
      const router = segment[0].path;

      if (router === 'about') {
        this.title.setTitle('درباره ما | سامانه ملی تجهیز ناوگان حمل‌ونقل جاده‌ای به GPS | ردیاب راهداری');
        this.fetchHTMLFile(1);
      }

      if (router === 'general') {
        this.title.setTitle('خدمات عمومی | سامانه ملی تجهیز ناوگان حمل‌ونقل جاده‌ای به GPS | ردیاب راهداری');
        this.fetchHTMLFile(2);
      }
    });
  }

  fetchHTMLFile(mode) {
    const url = mode === 1 ? 'assets/basic/Dyar_About.html' : 'assets/basic/Dyar_GeneralConditions.html';
    this.http.get(url, { responseType: 'text' }).subscribe(data => this.htmlContent = data);
  }

}
